import { Environment } from './environment.model';

export const environment: Environment = {
    production: true,
    API_URL: 'https://9d3dl9hyfl.execute-api.us-east-1.amazonaws.com/p1',
    redirectURL: 'https://arap.prod.ap.alight.com',
    externalCognitoTokenURL: "https://arap-prod-ext.auth.us-east-1.amazoncognito.com/oauth2/token",
    internalCognitoTokenURL: "https://arap-prod-int.auth.us-east-1.amazoncognito.com/oauth2/token",
    internalCognitoAuthorizeURL: "https://arap-prod-int.auth.us-east-1.amazoncognito.com/oauth2/authorize",
    sso_external_client_id: '51tuqs9s7p2ab29ds6dga4u386',
    sso_internal_client_id: '6d5ktvmfq5bue27p2uh9b75p4t',
    sso_api_pwd: '',
    identityPoolId: "us-east-1:1174b415-1477-4a54-a8c1-3dcd3fc572b6",
    showAIButton: true,
    chatEnabled: true,
    chatClientCodes: [],
    chatAllowedUserIdSubstrings: [],
    endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
    rumApplicationId: '2392eb36-ee08-4afd-9853-46c82497da6f',
    useApiMock: false, // Never use mock data in production
    websocketUrl: 'wss://gp93kk77cd.execute-api.us-east-1.amazonaws.com/prod',
    quicksightEmbedBaseUrl: "https://us-east-1.quicksight.aws.amazon.com/embed/",
};
